import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Actions
import { createSaveAgreementConstraint, getAgreementConstraint, createPriceAgreement } from '../../../actions/agreementConstraint'
import { getCustomerGroups } from '../../../actions/customerGroup'
import { getBrands } from '../../../actions/common'

// import styles
import './view.scss'

// Utils
import { hasAccess } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'

// Elements
import Panel from '../../../shared/elements/panel'
import Col from '../../../shared/elements/col'
import Row from '../../../shared/elements/row'
import Text from '../../../shared/elements/text'
import Radio from '../../../shared/elements/radio'
import Label from '../../../shared/elements/label'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import Textarea from '../../../shared/elements/textarea'
import Button from '../../../shared/elements/button'
import DropDown from '../../../shared/elements/dropDown'

class View extends Component {

  constructor (props) {
    super(props)
    this.state = {
      type: 'create',
      constraint: {
        AgreementConstraintId: 0,
        CustomerGroupId: 0,
        CustomerGroupName: '',
        WorkProvider: {},
        Name: 'New',
        Active: false,
        Comment: '',
        PriceType: 0,
        ConstraintBrands: []
      },
      usePriceList: true,
      pricemodels: [],
      selectedpricemodel: -1,
      createButtonActive: true
    }
    this.onInputChange = this.onInputChange.bind(this)
    this.saveAddConstraint = this.saveAddConstraint.bind(this)
    this.addConstraint = this.addConstraint.bind(this)
    this.getCustomerGroups = this.getCustomerGroups.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.onCreateAgreement = this.onCreateAgreement.bind(this)
    this.createPriceAgreement = this.createPriceAgreement.bind(this)
  }

  componentDidMount () {
    this.getAgreementConstraint(this.props)
    this.getCustomerGroups()
  }

  componentWillUpdate (nextProps) {
    if (nextProps.brands === null || nextProps.brands.length === 0) {
      this.props.getBrands()
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.item.AgreementConstraintId !== nextProps.item.AgreementConstraintId) {
      this.getAgreementConstraint(nextProps)
    }
  }

  onChange (e) {
    e.persist()
    let value = e.target.value

    if (e.target.type === 'radio') {
      value = (e.target.value === 'yes')
    }
    this.setState({
      type: 'edit',
      constraint: {
        ...this.state.constraint,
        [e.target.name]: value
      }
    }, () => {
      if (e.target.type === 'radio') {
        this.onBlur(e)
      }
    })
  }

  onBlur (e) {
    if (this.state.constraint.AgreementConstraintId !== undefined) {
      this.setState({ type: 'edit' }, () => {
        this.saveAddConstraint()
      })
    }
  }

  getCustomerGroups () {
    this.props.getCustomerGroups()
  }

  getAgreementConstraint (props) {
    if (typeof props.item.AgreementConstraintId !== 'undefined') {
      props.getAgreementConstraint(props.item.AgreementConstraintId).then((res) => {
        let constraint = res.data
        this.setState({
          type: 'edit',
          constraint: constraint
        })
      }, () => {
        this.props.onError()
      })
    } else {
      this.resetCreate()
    }
  }

  resetCreate () {
    this.setState({
      type: 'create',
      constraint: {
        AgreementConstraintId: 0,
        CustomerGroupId: 0,
        CustomerGroupName: '',
        WorkProvider: {},
        Name: 'New',
        Active: false,
        Comment: '',
        PriceType: 0,
        ConstraintBrands: []
      },
      pricemodels: [],
      selectedpricemodel: -1,
      createButtonActive: true
    })
  }

  onInputChange (e) {
    let value = e.target.value
    let name = e.target.name
    if (e === undefined) {
      e = name
    }
    if (name === 'PriceModelId') {
      this.setState({
        selectedpricemodel: Number(value)
      })
    } else {
      this.setState({
        constraint: {
          ...this.state.constraint,
          [name]: value
        }
      })
    }
  }
  createPriceAgreement (data) {
    this.props.createPriceAgreement(data)
  }
  onCreateAgreement () {
    let type = this.props.item.PriceType
    if (parseInt(this.state.selectedpricemodel, 10) === -1 && type !== 5 && type !== 6 && type !== 0 && this.state.usePriceList) {
      return false
    }
    let data = {
      ParentPriceModelId: this.state.selectedpricemodel,
      CustomerGroupId: this.state.constraint.CustomerGroupId,
      AgreementConstraintId: this.state.constraint.AgreementConstraintId,
      UseEstimationList: !this.state.usePriceList
    }
    this.setState({
      createButtonActive: false
    }, () => {
      this.props.createPriceAgreement(data).then((res) => {
        // window.toastr.success(translation('12271'), translation('13424'))
        this.props.getPriceLists()
        this.setState({
          createButtonActive: true
        })
        this.props.router.push('/agreements/' + this.state.constraint.AgreementConstraintId)
      }, (err) => {
        console.log(err)
        window.toastr.error(translation('12272'), translation('216'))
      })
    })
  }
  renderConstraint () {
    let { constraint } = this.state
    if (constraint === null) return null
    const renderOrderType = () => {
      let pricetype = '12288'
      switch (constraint.PriceType) {
        case 1:
          pricetype = '71'
          break
        case 2:
          pricetype = '785'
          break
        case 3:
          pricetype = '13361'
          break
        case 5:
          pricetype = '13360'
          break
        case 8:
          pricetype = '1396'
          break
        case 6:
          pricetype = '301'
          break
        case 0:
          pricetype = '73'
          break
        default:
          break
      }

      return (
        <Text labelText={translation('69')} value={translation(pricetype)} disabled />
      )
    }

    const renderCustomerGroup = () => {
      let customergroupname = ''
      if (this.props.item.CustomerGroupName !== null) {
        customergroupname = this.props.item.CustomerGroupName
      }
      return (
        <Text labelText={translation('12282')} value={customergroupname} disabled />
      )
    }

    const renderPriceModel = () => {
      let priceModels = this.props.pricemodels
      let type = this.props.item.PriceType
      let active = this.state.createButtonActive

      const onChange = ({target: { value }}) => {
        this.setState({
          usePriceList: value === 'yes'
        })
      }

      return (
        <div>
          <LabelWrapper labelText={15013}>
            <Radio onChange={onChange} value='yes' checked={this.state.usePriceList} labelText={47} />
            <Radio onChange={onChange} value='no' checked={!this.state.usePriceList} labelText={48} />
          </LabelWrapper>
          {type !== 5 && type !== 6 && type !== 0 && (
            <DropDown name='PriceModelId'
              labelText={1867}
              onChange={this.onInputChange}
              disabled={!this.state.usePriceList}
              value={this.state.selectedpricemodel}>
              <option value='-1' key='-1'>{translation('890')}</option>
              {priceModels !== null && priceModels.length > 0 && priceModels.map((val, i) => {
                if (val.Active) {
                  return (<option value={val.PriceModelId} key={val.PriceModelId}>{val.Name}</option>)
                }
              })}
            </DropDown>)}
          <Button disabled={!active} onClick={this.onCreateAgreement} labelText={12289} />
        </div>
      )
    }

    const renderbrands = () => {
      const renderBrand = (val, key) => {
        return (
          <Label key={key}>{val.BrandName}</Label>
        )
      }
      return (
        <div>
          {
            constraint.BrandSelectionType === 0 &&
            <div>
              <Label>{translation('13473')}</Label>
              <Label>{translation('381')}</Label>
            </div>
          }
          {
            constraint.BrandSelectionType > 0 &&
            <LabelWrapper labelText={translation('13473')}>
              {constraint.ConstraintBrands.map(renderBrand)}
            </LabelWrapper>
          }
        </div>
      )
    }

    return (
      <Col>
        <Panel title={translation('12284')}>
          <Text labelText={translation('30')} value={constraint.Name || ''} disabled />
          <Textarea labelText={translation('149')} value={constraint.Comment || ''} disabled />
          {renderOrderType()}
          {renderCustomerGroup()}
          {renderbrands()}
        </Panel>
        <Panel title={translation('1867')}>
          {renderPriceModel()}
        </Panel>
      </Col>
    )
  }

  addConstraint () {
    this.setState({ type: 'create' }, () => {
      this.props.createSaveAgreementConstraint(this.state.constraint).then((res) => {
        this.props.onSave(res.data, this.state.type)
        // window.toastr.success(translation('12290'), translation('13424'))
      }, (err) => {
        // Toastr
        // console.log('err', err.response.data.Errors)
        if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
          let errors = err.response.data.Errors
          let errText = ''
          for (let i = 0; i < errors.length; i++) {
            let dictKey = errors[i].DictionaryKey
            errText += '<br/>' + translation(dictKey)
          }
          window.toastr.error(translation(errText), translation('216'))
        } else {
          window.toastr.error(translation('12272'), translation('216'))
        }
        // Toastr
        // window.toastr.error(translation('13463'), translation('216'))
      })
    })
  }

  saveAddConstraint () {
    this.props.createSaveAgreementConstraint(this.state.constraint).then((res) => {
      this.props.onSave(res.data, this.state.type)
      this.setState({
        constraint: res.data
      })
    }, (err) => {
      // Toastr
      // console.log('err', err.response.data.Errors)
      if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
        let errors = err.response.data.Errors
        let errText = ''
        for (let i = 0; i < errors.length; i++) {
          let dictKey = errors[i].DictionaryKey
          errText += '<br/>' + translation(dictKey)
        }
        window.toastr.error(translation(errText), translation('216'))
      } else {
        window.toastr.error(translation('12285'), translation('216'))
      }
    })
  }

  render () {
    if (!hasAccess([6], this.props.auth.user.UserType)) return null
    return (
      <div>
        <Row>
          {this.renderConstraint()}
        </Row>
      </div>
    )
  }
}

View.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    brands: state.common.brands,
    customergroups: state.common.customergroups
  }
}

export default connect(mapStateToProps, {
  createSaveAgreementConstraint,
  getAgreementConstraint,
  getBrands,
  getCustomerGroups,
  createPriceAgreement
}, null, { withRef: true })(View)



// WEBPACK FOOTER //
// ./src/app/pages/PriceAgreements/View/index.js